import React from "react";
import { ShieldCheck, ShieldOff, BadgeCheck, Shield } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// ONE FILLED CHIP. Exactly one seller-verification chip ever renders, by strict precedence:
//   Revoked (#A33D28) > Dealer Verified (#1F6BA8) > ID Verified 'YY (#3A4A1E) > Not ID Verified
// Revoked wins the slot outright (and, at the call site, also suppresses the founding plate).
// Unverified renders an OUTLINED transparent chip, never a second filled one.
export function sellerChipKind({ revoked, dealer, idVerified }) {
  if (revoked) return "revoked";
  if (dealer) return "dealer";
  if (idVerified) return "id";
  return "none";
}

const CHIP = {
  revoked: { style: { backgroundColor: "#A33D28", color: "#F2D8D1", borderColor: "#A33D28" }, Icon: ShieldOff, label: () => "Verification Revoked" },
  dealer: { style: { backgroundColor: "#1F6BA8", color: "#EAF3FA", borderColor: "#1F6BA8" }, Icon: BadgeCheck, label: () => "Dealer Verified" },
  id: { style: { backgroundColor: "#3A4A1E", color: "#CFE0A4", borderColor: "#3A4A1E" }, Icon: ShieldCheck, label: (year) => (year ? `ID Verified '${String(year).slice(-2)}` : "ID Verified") },
  none: { style: { backgroundColor: "transparent", color: "#8E9195", borderColor: "#2E2F31" }, Icon: Shield, label: () => "Not ID Verified" },
};

export function SellerVerificationChip({ revoked, dealer, idVerified, idYear, size = "full", testid = "seller-verification-chip" }) {
  // Business/dealer is dark until we open to businesses — never show a Dealer Verified chip meanwhile.
  const { businessFeaturesEnabled } = useAuth();
  const kind = sellerChipKind({ revoked, dealer: dealer && businessFeaturesEnabled, idVerified });
  const c = CHIP[kind];
  const compact = size === "compact";
  const Icon = c.Icon;
  return (
    <span
      data-testid={testid}
      data-chip-kind={kind}
      style={c.style}
      className={`inline-flex items-center gap-1.5 border font-mono uppercase tracking-[1px] leading-none ${compact ? "px-2 py-[4px] text-[9px]" : "px-2.5 py-[6px] text-[10px]"}`}
    >
      <Icon className={compact ? "w-2.5 h-2.5 shrink-0" : "w-3 h-3 shrink-0"} strokeWidth={2} />
      {c.label(idYear)}
    </span>
  );
}
